import { Pipe, PipeTransform } from '@angular/core';

export function parseIsoDatetime(dtstr: string): Date {
  const dt = dtstr.split(/[: T-]/).map(parseFloat);
  return new Date(dt[0], dt[1] - 1, dt[2], dt[3] || 0, dt[4] || 0, dt[5] || 0, 0);
}

@Pipe({
  name: 'dateParse',
})
export class DateParsePipe implements PipeTransform {
  /**
   * Angular標準のDatePipeではISO8601の日付形式(主にsafari)を変換できないため、
   * 変換するpipeを挟む
   */
  transform(value: any | Date): Date | null {
    // Date型はそのまま返す
    if (value instanceof Date) { return value; }

    // number型はDate型に変換して返す
    if (typeof value === 'number') { return new Date(value); }

    // string型はパースして返す
    if (typeof value === 'string') {
      const parsed = Date.parse(value);
      if (Number.isNaN(parsed)) {
        const challenge = parseIsoDatetime(value);
        if (Number.isNaN(challenge.getTime())) {
          return null;
        }
        return challenge;
      }
      return new Date(value);
    }
    return null;
  }
}
